// Render Prop
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import FormElement from './FormElement';
import { Card, Box } from './style';
import { Col, Row, Button, Space } from 'antd';
import service from '../../services/objects';

export default ({
  formData,
  cancel,
  sendData,
  selectOptions,
  id,
  initialVal,
}) => {
  const [options, setOptions] = useState([]);
  const [objects, setObjects] = useState([]);
  const formik = useFormik({
    initialValues: initialVal,
    onSubmit: (values) => {
      id ? sendData(id, values) : sendData(values);
    },
  });
  useEffect(() => {
    if (formik.values.role === 'groupadmin' && formik.values.region) {
      const payload = {
        parent: '62e7b2e89ea2ff5d7fa7d092',
        region: formik.values.region,
      };
      service
        .getAllSubsList(payload)
        .then((resp) => {
          setObjects(resp);
        })
        .catch((err) => console.log(err));
    }
  }, [formik.values.region]);

  useEffect(() => {
    if (!formik?.values?.parent) {
      const filteredData = formData?.data?.filter((item) =>
        item?.isShow?.includes('parent')
      );
      setOptions(filteredData);
    }
    if (formik?.values?.parent) {
      const filteredData = formData?.data?.filter((item) =>
        item?.isShow?.includes('child')
      );
      setOptions(filteredData);
    }
  }, [formik?.values?.parent]);

  useEffect(() => {
    if (formik.values?.role && formik.values?.role !== 'editor') {
      const filteredData = formData.data.filter((item) =>
        item?.permission?.includes(formik?.values?.role)
      );
      setOptions(filteredData);
    }
  }, [formik.values.role]);

  const handleCancel = () => {
    cancel();
  };
  const checkOptions = () => {
    return options.length > 0 ? options : formData.data;
  };

  return (
    <Box>
      <Card>
        <form onSubmit={formik.handleSubmit}>
          <Row align='left' gutter={[16, 8]}>
            {checkOptions().map((item, ind) => (
              <Col span={item.size} key={ind + 1} align='left'>
                <div className='label'>{item.label}</div>
                <FormElement
                  formik={formik}
                  item={item}
                  selectOptions={{ ...selectOptions, object: objects }}
                  id={id}
                />
              </Col>
            ))}
          </Row>
          <Space
            style={{ marginTop: '20px', display: 'block', align: 'right' }}
          >
            <Row justify='end' gutter={[8, 8]}>
              <Col>
                <Button onClick={() => handleCancel()}>Бекор қилиш</Button>
              </Col>
              <Col>
                <Button type='primary' htmlType='submit'>
                  {id ? 'Янгилаш' : 'Сақлаш'}
                </Button>
              </Col>
            </Row>
          </Space>
        </form>
      </Card>
    </Box>
  );
};
